module.exports = __webpack_public_path__ + "static/media/gold-foil-2px.cd1665e7.png";